import Auth from '../../../modules/Auth'
import Global from '../../../constants/Global.js'

export function checkEmail(email) {
  return new Promise((resolve) => {
    fetch(Global.getServerDomain() + `/emailAvailability`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: email
      })
    })
      .then(function (res) {
        resolve(res.json())
      })
      .catch(error => console.error('Error: ', error))
  })
}

export function checkUsernameAvailability(username) {
  return new Promise((resolve) => {
    fetch(Global.getServerDomain() + `/usernameAvailability`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username: username
      })
    })
      .then(function (res) {
        resolve(res.json())
      })
      .catch(error => console.error('Error: ', error))
  })
}

export function checkUsernameActivated(username) {
  return new Promise((resolve) => {
    fetch(Global.getServerDomain() + `/checkUsernameActivated`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username: username
      })
    })
      .then(function (res) {
        resolve(res.json())
      })
      .catch(error => console.error('Error: ', error))
  })
}

export function checkEmailActivated(email) {
  return new Promise((resolve) => {
    fetch(Global.getServerDomain() + `/checkEmailActivated`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        email: email
      })
    })
      .then(function (res) {
        resolve(res.json())
      })
      .catch(error => console.error('Error: ', error))
  })
}

export async function signup({ commit }, input) {
  const fetchUrl = Global.getServerDomain() + '/signup'
  const fetchType = 'POST'
  const bodyInput = {
    username: input.username,
    email: input.email,
    password: input.password,
    codeFromInviter: input.code,
  }

  return await new Promise(() => {
    fetch(fetchUrl, {
      method: fetchType,
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(bodyInput)
    })
      .then(function (res) {
        if (res.status === 200) {
          commit("register_success");
        }
        return res.json()
      }).then(function (payload) {
        commit("registration_response", payload);
      })
      .catch(error => console.error('Error: ', error))
  })
}

export async function startSession({ commit, dispatch }) {
  return await new Promise((resolve) => {
    fetch(Global.getServerDomain() + `/profile`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      }
    })
      .then(function (res) {
        return res.json()
      })
      .then(function (userInfo) {
        commit('start_session', userInfo)
        resolve();
        dispatch("fetchUserInventory", userInfo.id)
        if (!userInfo.cookies_privacy && (localStorage.getItem('cookies_privacy') === 'true')) {
          let updatedUser = null;
          updatedUser = { ...userInfo };
          updatedUser.cookies_privacy = true;
          dispatch('prepareUpdatedUser', { ...updatedUser })
          try {
            dispatch('updateUser');
          } catch (error) {
            console.log(error);
          }
        }
      })
      .catch(error => console.error(error))
  });
}

export async function endSession({ commit }) {
  fetch(Global.getServerDomain() + `/logout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  })
    .then(function (res) {
      return res.json()
    })
    .then(function () {
      commit('end_session')
    })
    .catch(error => console.error(error))
}

export async function fetchMySession({ commit }) {
  fetch(Global.getServerDomain() + `/session`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (payload) {
      commit('my_session', payload)
    })
    .catch(error => console.error(error))
}

export function refreshUser({ commit }) {
  fetch(Global.getServerDomain() + `/profile`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (userInfo) {
      commit('refresh_user', userInfo)
    })
    .catch(error => console.error(error))
}

export function prepareUpdatedUser({ commit }, update) {
  commit('updated_user', update)
}

export async function updateUser({ commit, state }) {
  await fetch(Global.getServerDomain() + `/profile`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    },
    body: JSON.stringify(state.updated_user)
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (userInfo) {
      commit('update_user', userInfo)
    })
    .catch(error => console.error(error))
}

export async function fetchUserProfile({ commit, dispatch }, userId) {
  const result = await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/profile/${userId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      }
    })
      .then(function (res) {
        resolve(res.json())
      }).then((user) => {
        
        if (user && (!user.cookies_privacy && (localStorage.getItem('cookies_privacy') === 'true'))) {
          let updatedUser = null;
          updatedUser = { ...user };
          updatedUser.cookies_privacy = true;
          dispatch('prepareUpdatedUser', { ...updatedUser })
          try {
            dispatch('updateUser');
          } catch (error) {
            console.log(error);
          }
        }
      })
      .catch(error => console.error(error))
  });
  
  
  commit('user_profile', result);
}

export function changePassword({ commit, state }, update, token) {
  if (!token) token = Auth.getToken()

  fetch(Global.getServerDomain() + `/changePassword`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': token
    },
    body: JSON.stringify(update)
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (userInfo) {
      if (userInfo.error) state.error = userInfo.error
      commit('change_password', userInfo)
    })
    .catch(error => console.error(error))
}

export function getMyMessages({ commit }) {
  fetch(Global.getServerDomain() + `/messages`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (payload) {
      if (payload.length > 0) {
        commit('update_threads', payload)
      }
    })
    .catch(error => console.error(error))
}

export function getMyInvitations({ commit }) {
  fetch(Global.getServerDomain() + `/invitations`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (payload) {
      if (payload.length > 0) {
        commit('my_invitations', payload)

      }
    })
    .catch(error => console.error(error))
}

export async function fetchMyInvitations({ commit }) {
  const result = fetch(Global.getServerDomain() + `/invitations`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (payload) {
      commit('my_invitations', payload)
    })
    .catch(error => console.error(error))
  return result;
}

export function getUserSearch({ commit }, query) {
  fetch(Global.getServerDomain() + `/profile/search`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    },
    body: JSON.stringify({
      query: query
    })
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (payload) {
      if (payload) {
        const searchResult = []
        let rowIndex = payload.length - 1
        payload.forEach(function (element) {
          const item = {}
          item.SUer = element
          item.User_id = element.id
          item.Username = element.username
          item.Picture = element.picture
          item.Description = element.description
          item.Zip = element.zip
          item._showDetails = false
          item.index = rowIndex
          rowIndex--
          searchResult.push(item)
        }, this)
        commit('search_users', searchResult)
      }
    })
    .catch(error => console.error(error))
}

export async function fetchMyJoinRequests({ commit }) {
  const result = fetch(Global.getServerDomain() + `/joinrequests`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (payload) {
      commit('my_join_requests', payload)
    })
    .catch(error => console.error(error))
  return result;
}

export async function acceptJoinInvitation({ state, dispatch }, { groupId, partnerId, groupName }) {
  return await new Promise((resolve) => {
    fetch(Global.getServerDomain() + `/group/${groupId}/acceptjoininvitation`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify({
        user: state.session_user.id
      })
    })
      .then(function (res) {
        dispatch('mergeRequests')
        dispatch('getAllGroups')
        let message = `Welcome to the ${groupName} group. Click <a onMouseOver="this.style.color='black'" onMouseOut="this.style.color='white'" style="color:white;text-decoration:underline !important;" href="${Global.getFrontDomain()}/s-app/group-page/${groupId}">here</a> to go to the group's home page.`;
        dispatch('sendSystemNotification', { partnerId: partnerId, msg: message, type: "JOIN_PUBLIC_GROUP" })
        resolve(res.json())
      })
      .catch(error => console.error(error))
  })
}

export async function declineJoinInvitation({ state, dispatch }, { groupId }) {
  return await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/group/${groupId}/declinejoininvitation`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify({
        user: state.session_user.id
      })
    })
      .then(function (res) {
        dispatch('fetchMyInvitations')
        resolve(res.json())
      })
      .catch(error => console.error(error))
  })

}

export function cancelJoinRequest({ state, dispatch }, groupId) {
  fetch(Global.getServerDomain() + `/group/${groupId}/canceljoinrequest`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    },
    body: JSON.stringify({
      user: state.session_user.id
    })
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (payload) {
      if (payload) {
        dispatch('fetchMyJoinRequests')
        dispatch('getAllGroups')
      }
    })
    .catch(error => console.error(error))
}

export async function fetchModeratorInvitationsData({ commit }) {
  const result = fetch(Global.getServerDomain() + `/moderatorinvitations`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (payload) {
      commit('my_moderator_invitations', payload)
    })
    .catch(error => console.error(error))
  return result;
}

export function acceptModeratorInvitation({ state, dispatch }, groupId) {
  fetch(Global.getServerDomain() + `/group/${groupId}/acceptmoderatorinvitation`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    },
    body: JSON.stringify({
      user: state.session_user.id
    })
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (payload) {
      if (payload) {
        dispatch('fetchModeratorInvitationsData')
        dispatch('getAllGroups')
      }
    })
    .catch(error => console.error(error))
}

export function rejectModeratorInvitation({ state, dispatch }, groupId) {
  fetch(Global.getServerDomain() + `/group/${groupId}/rejectmoderatorinvitation`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    },
    body: JSON.stringify({
      user: state.session_user.id
    })
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (payload) {
      if (payload) {
        dispatch('fetchModeratorInvitationsData')
        dispatch('getAllGroups')
      }
    })
    .catch(error => console.error(error))
}

export async function sendSupportRequest({ getters, state, commit }, { message, user }) {

  commit("set_request_response", "SENDING");
  let userToSend;
  if (getters.isUserAuthenticated) {
    userToSend = { ...state.session_user, ...user };
  } else {
    userToSend = user;
  }

  fetch(Global.getServerDomain() + `/sendSupportRequest`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    },
    body: JSON.stringify({
      user: userToSend,
      message: message
    })
  })
    .then(function (res) {
      if (res.status === 200) commit("set_request_response", "SENT");
      else commit("set_request_response", "ERROR");
      return res.json()
    })
    .then(function (payload) {
      return payload;
    })
    .catch(error => console.error(error))
}

export function sendSupport(support) {
  fetch(Global.getServerDomain() + `/sendSupport`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(support)
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (payload) {
      return payload;
    })
    .catch(error => console.error(error))
}

export function fetchMyNotifications({ commit }) {
  fetch(Global.getServerDomain() + `/notification`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'auth_key': Auth.getToken()
    }
  })
    .then(function (res) {
      return res.json()
    })
    .then(function (payload) {
      commit('my_notifications', payload)
    })
    .catch(error => console.error(error))
}

export async function passwordForgot({ commit }, username) {
  try {
    const result = fetch(Global.getServerDomain() + '/passwordForgot', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        username: username
      })
    })
      .then(function (res) {
        return res.json()
      })
      .then(function (response) {
        commit('password_forgot', response);
        if (!response.error) {
          commit('password_forgot', response);
        } else if (response.error === 'User already authenticated.') {
          commit('password_forgot', response.error);
        }
      })
    return result;
  } catch (error) {
    console.log(error)
  }

}
export function resetResponse({ commit }) {
  commit('reset_response');
}

export async function fetchProfileItems({ commit }, userId) {
  const result = await new Promise((resolve) => {
    fetch(Global.getServerDomain() + `/profile/${userId}/items`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      }
    })
      .then(function (res) {
        resolve(res.json());
      })
      .catch(error => console.error(error))
  })
  commit('profile_items', result)

}

export async function fetchProfileGroups({ commit }, userId) {
  const result = await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/profile/${userId}/groups`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      }
    })
      .then(function (res) {
        resolve(res.json())
      })
      .catch(error => console.error(error))
  })
  commit('profile_groups', result)
}

export async function forgotUsername({ commit }, email) {
  try {
    const result = fetch(Global.getServerDomain() + "/usernameForgot", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        // username: this.credentials.username,
        email: email
        // password: this.credentials.password
      })
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (response) {
        if (!response.error) {
          commit('password_forgot', response);
        } else {
          commit('password_forgot', response);
          if (response.error === "Invalid email.") {
            commit('password_forgot', response);
          }
        }
      });
    return result;
  } catch (error) {
    commit('password_forgot', error);
    console.log(error)
  }
}

export async function mergeRequests({ commit, dispatch, rootGetters }) {
  await dispatch('fetchMyInvitations')
  await dispatch('fetchMyJoinRequests')
  await dispatch('fetchModeratorInvitationsData')
  const myInvitations = rootGetters.getMyInvitations;
  const myJoinRequests = rootGetters.getMyJoinRequests;
  const myModeratorInvitations = rootGetters.getMyModeratorInvitations;
  let invitations = myInvitations.map(item => {
    if (item) {
      return {
        ...item,
        type: "myInvitations"
      }
    } else {
      return []
    }
  })

  let joinRequests = myJoinRequests.map(item => {
    if (item) {
      return {
        ...item,
        type: "myJoinRequests"
      }
    } else {
      return []
    }
  })

  let moderatorInvitations = myModeratorInvitations.map(item => {
    if (item) {
      return {
        ...item,
        type: "myModeratorInvitations"
      }
    } else {
      return []
    }
  })
  let arr = [
    ...invitations,
    ...joinRequests,
    ...moderatorInvitations
  ];
  arr.sort((a, b) => {
    if (a.createdAt == null) {
      return 1;
    }
    if (b.createdAt == null) {
      return -1;
    }
    return b.createdAt - a.createdAt;
  });
  commit("set_all_invitations_requests", arr);

}

export async function uploadHeaderPhoto({ commit }, { photo, id }) {
  const url = Global.getServerDomain() + '/images/user/header/' + id;
  const fetchType = 'POST';
  const bodyInput = photo;
  const options = {
    method: fetchType,
    headers: {
      'auth_key': Auth.getToken()
    },
    body: bodyInput,
  };
  return await new Promise((resolve) => {
    fetch(url, options).then(function (res) {
      resolve(res.json())
      if (res.status === 200) {
        commit("header_photo", photo);
      }
    }).catch(error => console.error('Error: ', error))
  });
}

export async function updateProfilePhoto(commit, { photo, id }) {
  const url = Global.getServerDomain() + '/images/user/' + id;
  const fetchType = 'POST';
  const bodyInput = photo;
  const options = {
    method: fetchType,
    headers: {
      'auth_key': Auth.getToken()
    },
    body: bodyInput,
  };
  return await new Promise((resolve) => {
    fetch(url, options).then(function (res) {
      resolve(res.json())
    }).catch(error => console.error('Error: ', error))
  });
}

export async function removeProfilePhoto(commit, id ) {
  const url = Global.getServerDomain() + '/images/user/remove/' + id;
  const fetchType = 'POST';
  
  const options = {
    method: fetchType,
    headers: {
      'auth_key': Auth.getToken()
    },
  };
  return await new Promise((resolve) => {
    fetch(url, options).then(function (res) {
      resolve(res.json())
    }).catch(error => console.error('Error: ', error))
  });
}

export function setNewProfileImage({ commit }, image) {
  commit('set_profile_image', image)
}

export function setNewProfileImageOrientation({ commit }, imageOrientation) {
  commit('set_profile_image_orientation', imageOrientation)
}

export function setNewProfileImageFile({ commit }, imageFile) {
  commit('set_profile_image_file', imageFile)
}

export async function emailUpdate({ commit, dispatch }, { email, password }) {
  const result = await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/emailChangeRequest`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify({
        email: email,
        password: password
      })
    })
      .then(res => {
        resolve(res.json());
      }).catch(error => console.log("Error: ", error))
  });
  commit('set_request_response', result);
  dispatch('refreshUser');
}

export async function deactivation(commit, { userId, userPassword }) {
  const result = await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/deactivation`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify({
        id: userId,
        currentPassword: userPassword,
      })
    })
      .then(res => {
        resolve(res.json());
      })
      .catch(error => {
        console.log("Error: ", error)
      })
  });
  return result;
}

export async function checkSuperuser(commit, userId) {
  return await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/profile/${userId}/super`, {
      method: 'GET',
      headers: {
        'auth_key': Auth.getToken()
      }
    })
      .then(function (res) {
        resolve(res.json());
      })
      .catch(error => console.error(error))
  })
}

export async function invitationEmail(commit, { email, name }) {
  const result = await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/joininvitationemail`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify({
        email: email,
        name: name,
        message: 'invite friend'
      })
    })
      .then(res => {
        resolve(res.json());
      })
      .catch(error => {
        console.log("Error: ", error)
      })
  });
  return result;
}

export async function checkSessionDueDate(commit, { token }) {
  const result = await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/profile/session/check`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': token
      },
    })
      .then(res => {
        resolve(res.json());
      })
      .catch(error => {
        console.log("Error: ", error)
      })
  });
  return result;
}

export async function resendActivation(commit, { email, token }) {
  const result = await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/resentconfirm`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': token
      },
      body: JSON.stringify({
        username: email,
      })
    })
      .then(res => {
        resolve(res.json());
      })
      .catch(error => {
        console.log("Error: ", error)
      })
  });
  return result;
}
export async function getUserLocation() {
  const result = await new Promise((resolve) => {
    fetch("https://extreme-ip-lookup.com/json/?key=HbVfB4G0C3OOuwtLVghj")
      .then((res) => res.json())
      .then((res) => {
        resolve(res)
      })
      .catch((error) => {
        console.log("Request failed", error);
      });
  });
  return result;
}
export async function saveUserLocation(commit, { location }) {
  const result = await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/profile/location`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'auth_key': Auth.getToken()
      },
      body: JSON.stringify({
        country: location,
      })
    })
      .then(res => {
        resolve(res.json());
      })
      .catch(error => {
        console.log("Error: ", error)
      })
  });
  return result;
}
export async function commitScrollStatus({ commit }, { isBottom }) {
  commit('set_is_scroll_bottom', isBottom);
}

export async function getDontShowModal( commit , { modalType, userId }) {
  const result = await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/dontShowAgain/${modalType}/${userId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(res => {
        resolve(res.json());
      })
      .catch(error => {
        console.log("Error: ", error)
      })
  });
  return result;
}

export async function saveDontShowAgain( commit , { modal_Type, user_Id } ) {
  console.log(modal_Type, user_Id);
  const result = await new Promise(resolve => {
    fetch(Global.getServerDomain() + `/dontShowAgain`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        modalType: modal_Type,
        userId: user_Id,
      })
    })
      .then(res => {
        resolve(res.json());
      })
      .catch(error => {
        console.log("Error: ", error)
      })
  });
  return result;
}

export function setIsFirstLogin({ commit }, isFirstLogin) {
  commit('set_is_first_login', isFirstLogin);
}
